// @ts-nocheck
/**
 *
 * GlobalAudioPlayer
 *
 */
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components/macro';
import ReactAudioPlayer from 'react-audio-player';
import {useDispatch, useSelector} from "react-redux";
import {
  selectCurrentSong,
  selectIsPlaying,
  selectProgress,
  selectHistoryStack,
  selectQueue
} from "app/components/GlobalAudioPlayer/slice/selectors";
import {useGlobalAudioSlice} from 'app/components/GlobalAudioPlayer/slice/index'
import {useAcapellasSlice} from "app/pages/AcapellasPage/slice/index";
import {Slider, SliderThumb} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faForwardStep, faPause, faPlay} from "@fortawesome/pro-solid-svg-icons";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import {
  OldPrice,
  Price,
  PriceAndDiscountContainer,
  PriceContainer,
  PriceDiscount
} from "app/components/GlobalAudioPlayer/priceAndDiscountContainer";
import {getTypeOfControllaPrice} from "app/components/CustomizeAcapellaStackModal";
import {useOutletContext} from "react-router-dom";
import toast from "react-hot-toast";
import {selectSelectedPreviewVoice} from "app/pages/VoiceModelsPage/slice/selectors";


const DEFAULT_COVER_IMAGE_URL = "https://storage.googleapis.com/controlla-public-images/ControllaVoiceLogo.png"

interface Props {}

// Changing pitch with playback speed, Convert transpose to playbackRate for audio element
// https://www.reddit.com/r/audioengineering/comments/1r48ft/changing_pitch_with_playback_speed/
// Yup. For more detail, the formula is (2^(n/12) - 1) * 100%, where n is the number of semitones. So to pitch up 1 semitone, 21/12 - 1 = 0.05946 = 5.946 %
function transposeToPlaybackRate(transpose) {
  return ((2 ** (transpose / 12)) - 1) + 1
}

function durationToSecText(duration) {
  const durationSecs = Math.floor(duration)
  // @ts-ignore
  const durationMins = Math.floor(durationSecs / 60)
  const durationSecsRemainder = durationSecs % 60
  const durationText = `${durationMins}:${durationSecsRemainder > 9 ? durationSecsRemainder : '0' + durationSecsRemainder}`
  return durationText
}

function NumberSliderThumb(props) {
  const { children, ...other } = props;
  return <SliderThumb {...other}>
    {children}
    <TransposeThumb>
      {props.value}
    </TransposeThumb>
  </SliderThumb>
}

export function GlobalAudioPlayer(props: Props) {
  const dispatch = useDispatch();
  const currentSong = useSelector(selectCurrentSong)
  const isPlaying = useSelector(selectIsPlaying)
  const queue = useSelector(selectQueue)
  const historyStack = useSelector(selectHistoryStack)
  const [userProfile, isLoaded, isSignedIn] = useOutletContext();
  const progress = useSelector(selectProgress)
  const { actions } = useGlobalAudioSlice()
  const { actions: acapellasActions } = useAcapellasSlice()
  const previewVoice = useSelector(selectSelectedPreviewVoice);
  const audioRef = useRef(null);
  const [duration, setDuration] = useState(0)
  const [transpose, setTransposeState] = useState(0)
  const [masterVolume, setMasterVolumeState] = useState(1)


  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const acapellaStack = currentSong?.acapellaStack;

  useEffect(() => {
    console.log('useeffect audio', audioRef)
    // @ts-ignore
    let audioEl = audioRef.current?.audioEl.current
    let playbackRate = transposeToPlaybackRate(transpose)
    console.log(playbackRate)
    audioEl.playbackRate = playbackRate
    audioEl.preservesPitch = false
    if (!isPlaying) {
      console.log('pause')
      // @ts-ignore
      audioEl.pause();
    }
    if (isPlaying) {
      console.log('pause')
      audioEl.play();
    }
  }, [isPlaying])

  // Reset song if user logs out
  useEffect(() => {
    if (!isSignedIn) {
      console.log('hiding global audio player on sign out')
      dispatch(actions.setCurrentSong(undefined))
    }
  }, [isSignedIn])

  // update progress if it changes from Redux store
  useEffect(() => {
    if (audioRef.current?.audioEl.current) {
      const audioEl = audioRef.current.audioEl.current;
      const currentTime = progress;
      if (Math.abs(currentTime - audioEl.currentTime) > 1) {
        audioEl.currentTime = currentTime;
      }
    }
  }, [progress])

  const setMasterVolume = (v) => {
    setMasterVolumeState(v)
  }

  const setTranspose = (t) => {
    // @ts-ignore
    let audioEl = audioRef.current?.audioEl.current
    let playbackRate = transposeToPlaybackRate(t)
    console.log(playbackRate)
    audioEl.playbackRate = playbackRate
    audioEl.preservesPitch = false
    setTransposeState(t)
  }

  const handleListen = (e) => {
    dispatch(actions.setProgress(e))
  }

  const handlePause = (e) => {
    dispatch(actions.setIsPlaying(false))
  }

  const handlePlay = (e) => {
    dispatch(actions.setIsPlaying(true))
  }

  const handleCustomize = () => {
    console.log('customize')
    // TEMP hack to fix broken model if no voice selected, force voice selection
    if (!previewVoice) {
      toast('Select A Voice to Preview Songs')
    } else {
      dispatch(acapellasActions.setSelectedAcapella(acapellaStack))
    }
  }


  const handleLoadedMetadata = (e) => {
    console.log('metadata loaded: ', e)
    console.log('audio', audioRef)
    // @ts-ignore
    let audioEl = audioRef.current?.audioEl.current
    setDuration(audioEl.duration)
  }

  const handleMouseDownOnProgress = (e) => {
    console.log('mouse downw', e.target.value)
    let audioEl = audioRef.current?.audioEl.current
    let currentTime = (e.target.value / 100) * audioEl.duration
    audioEl.currentTime = currentTime
    dispatch(actions.setProgress(currentTime))
  }

  const handleClickPrev = (e) => {
    console.log('click prev')
    let audioEl = audioRef.current?.audioEl.current
    let currentTime = audioEl.currentTime
    // if theres songs in history and we're in the first 3 sec of this song skip to prev
    if (historyStack.length > 0 && (currentTime < 3)) {
      // Play prev song
      dispatch(actions.playPrevSongFromStack())
    } else {
      // else just restart this track
      let audioEl = audioRef.current?.audioEl.current
      audioEl.currentTime = 0
      dispatch(actions.setProgress(0))
    }
  }

  const handleClickNext = (e) => {
    console.log('click next')
    if (queue.length > 0) {
      // Play next song
      dispatch(actions.playNextSongFromQueue())
    }
  }

  const handleEnded = (e) => {
    // TEMP - disable auto play
    // if (queue.length > 0) {
    //   // Play next song
    //   dispatch(actions.playNextSongFromQueue())
    // }
  }

  const durationText = durationToSecText(duration)
  const progressText = durationToSecText(progress)



  const creditBalance = userProfile?.marketplace_credits

  const getPrice = () => {
    if (!acapellaStack.controlla_price) return 0;
    const personalControllaPrice = getTypeOfControllaPrice(acapellaStack?.controlla_price, false)
    const price = personalControllaPrice.price
    return price
  }

  const getPriceAsCredits = () => {
    const priceAsCredits = getPrice() * 100
    return priceAsCredits
  }

  const getPriceText = (isOld = false) => {
    let showPriceAsCredits = getPriceAsCredits() <= creditBalance
    let priceAsCredits = isOld ? getPriceAsCredits() * 2 : getPriceAsCredits()
    let price = isOld ? getPrice() * 2 : getPrice()
    return showPriceAsCredits ? (priceAsCredits + ' credits') : '$' + (price).toFixed(2)
  }

  const songThumbnailEl = (
      <SongThumbnailRow isMobile={isMobile}>
        {isMobile && (
          <PlayButton isMobile={isMobile} onClick={isPlaying ? handlePause : handlePlay}>
            <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
          </PlayButton>
        )}
        <SongCoverImage isMobile={isMobile} src={currentSong?.coverUrl || DEFAULT_COVER_IMAGE_URL}/>
        <SongInfo>
          <SongTitle>
            {currentSong?.title}
          </SongTitle>
          {currentSong?.singer?.length > 1 && (
            <SongSinger>
              {'Covered by ' + currentSong?.singer}
            </SongSinger>
          )}
        </SongInfo>
      </SongThumbnailRow>
  );
  const playerControlsEl = (
      <PlayerControls isMobile={isMobile}>
        {/* Move play button to overlay cover on mobile */}
        {!isMobile && (
          <PlayerActions>
            <PlayButton onClick={handleClickPrev}>
              <FontAwesomeIcon icon={faForwardStep} style={{ transform: 'rotate(180deg)' }}/>
            </PlayButton>
            <PlayButton isMobile={isMobile} onClick={isPlaying ? handlePause : handlePlay}>
              <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
            </PlayButton>
            <PlayButton onClick={handleClickNext}>
              <FontAwesomeIcon icon={faForwardStep} />
            </PlayButton>
          </PlayerActions>
        )}
        <PlayerProgressBar>
          <ProgressText isMobile={isMobile}>{progressText}</ProgressText>
          <Slider
              onChange={handleMouseDownOnProgress}
              style={{flexGrow: 1}}
              value={(progress / duration) * 100}
              sx={{
                color: theme.palette.mode === 'dark' ? '#FF74E9' : 'rgba(0,0,0,0.87)',
                height: 4,
                padding: '0px !important',
                '& .MuiSlider-thumb': {
                  width: 8,
                  height: 8,
                  transition: '0.3s cubic-bezier(.47,1.64,.41,.8)',
                  '&:before': {
                    boxShadow: '0 2px 12px 0 rgba(0,0,0,0.4)',
                  },
                  '&:hover, &.Mui-focusVisible': {
                    boxShadow: `0px 0px 0px 8px ${
                        theme.palette.mode === 'dark'
                            ? 'rgb(255 255 255 / 16%)'
                            : 'rgb(0 0 0 / 16%)'
                    }`,
                  },
                  '&.Mui-active': {
                    width: 20,
                    height: 20,
                  },
                },
                '& .MuiSlider-rail': {
                  opacity: 0.28,
                },
                '& .MuiSlider-root': {
                  height: '4px',
                },
              }}
          />
          <ProgressText isMobile={isMobile}>{durationText}</ProgressText>
        </PlayerProgressBar>
      </PlayerControls>
  );
  const songActionsEl = (
    <>
          <SongActions isMobile={isMobile}>
            <TransposeContainer>
              <TransposeInput>
                <Slider variant="transpose" slots={{ thumb: NumberSliderThumb }} slotProps={{ thumb: { value: transpose } }} size={"small"} track={false} value={transpose} step={1} marks min={-12} max={12} onChange={(e) => setTranspose(e.target.value) } />
              </TransposeInput>
              Pitch & Speed
            </TransposeContainer>
            <VolumeContainer>
              <VolumeInput>
                <Slider variant="transpose" slots={{ thumb: NumberSliderThumb }} slotProps={{ thumb: { value: masterVolume } }} size={"small"} value={masterVolume} step={0.1} marks min={0} max={1} onChange={(e) => setMasterVolume(e.target.value) } />
              </VolumeInput>
              Volume
            </VolumeContainer>
            {acapellaStack && acapellaStack?.controlla_price && (
              <>
                <PriceAndDiscountContainer>
                  <PriceContainer>
                    <OldPrice>
                      {getPriceText(true)}
                    </OldPrice>
                    <Price>
                      {getPriceText(false)}
                    </Price>
                  </PriceContainer>
                  <PriceDiscount>
                    50% OFF!
                  </PriceDiscount>
                </PriceAndDiscountContainer>
                <button className="primary-button small" onClick={handleCustomize}>
                  GET FULL SONG
                </button>
              </>
            )}
            &nbsp;
          </SongActions>
    </>
  );



  return <GlobalAudioPlayerFooter style={{display: currentSong ? 'block' : 'none'}}>
    {isMobile ? (
      //   Mobile layout
      <AudioPlayerFooterContent isMobile={isMobile}>
        {playerControlsEl}
        {songThumbnailEl}
        {songActionsEl}
      </AudioPlayerFooterContent>
    ) : (
      //  desktop layour
      <AudioPlayerFooterContent isMobile={isMobile}>
        {songThumbnailEl}
        {playerControlsEl}
        {songActionsEl}
      </AudioPlayerFooterContent>
    )}
    <div style={{display: 'none'}}>
      <ReactAudioPlayer
          ref={audioRef}
          src={currentSong?.url}
          autoPlay={isPlaying}
          controls
          controlsList="nodownload"
          crossOrigin={"anonymous"}
          listenInterval={100}
          onListen={handleListen}
          onLoadedMetadata={handleLoadedMetadata}
          onEnded={handleEnded}
          volume={masterVolume}
      />
    </div>
  </GlobalAudioPlayerFooter>;
}

const GlobalAudioPlayerFooter = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100vw;
  z-index: 10;
  
  background: #180d23;
`;

const AudioPlayerFooterContent = styled.div<{ isMobile?: boolean; }>`
  display: flex;
  flex-direction: ${(props) => props.isMobile ? 'column' : 'row' };
  justify-content: ${(props) => props.isMobile ? 'flex-start' : 'space-between' };
  align-items: ${(props) => props.isMobile ? 'stretch' : 'center' };
`;

const SongThumbnailRow = styled.div<{ isMobile?: boolean; }>`
  max-width: ${(props) => props.isMobile ? '100%' : '30%' };
  overflow: hidden;
  flex-grow: 1;
  
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  
  position: relative; // needed to position play button absolute in mobile
`;

const SongCoverImage = styled.img<{ isMobile?: boolean; }>`
  width: 60px;
  height: 60px;
  margin: 15px;
  border-radius: 10px;
`;

const SongInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  max-width: calc(100% - 100px);
`;

const PlayerControls = styled.div<{ isMobile?: boolean; }>`
  width: ${(props) => props.isMobile ? '100%' : '30%' };
  flex-grow: 0;
  
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

const PlayerProgressBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
`;

const PlayerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const SongActions = styled.div<{ isMobile?: boolean; }>`
  width: ${(props) => props.isMobile ? '100%' : '30%' };
  flex-grow: 1;
  
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  
  background: ${(props) => props.isMobile ? '#250c3d' : 'unset' };;
  
`;

const ProgressText = styled.div<{ isMobile?: boolean; }>`
  font-family: 'Jura', sans-serif;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
  
  display: ${(props) => props.isMobile ? 'none' : 'block' };
  
`;

const PlayButton = styled.button<{ isMobile?: boolean; }>`
  position: ${(props) => props.isMobile ? 'absolute' : 'relative' };
  top: ${(props) => props.isMobile ? '25px' : 'unset' };
  left: ${(props) => props.isMobile ? '25px' : 'unset' };
  
  background-color: ${(props) => props.isMobile ? '#180d23ff' : 'unset' };
  border: none;
  padding: 5px 10px;
  
  border-radius: 50%;
  color: #f5e1ff;
  
  width: 40px;
  height: 40px;
  font-size: 18px;
  
  &:hover {
    background: ${(props) => props.isMobile ? '#180d23AA' : '#f5e1ff22' };
  }
`;

const SongTitle = styled.div`
  color: #FFF;

  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const SongSinger = styled.div`
  color: #f5e1ff;

  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const TransposeContainer = styled.div`
  width: 120px;
  font-family: Raleway;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  margin-right: 20px;
`;

const TransposeInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 5px;
`;

const TransposeThumb= styled.div`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: rgba(245, 225, 255, 0.74);
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const VolumeContainer = styled.div`
  width: 120px;
  font-family: Raleway;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  margin-right: 20px;
`;

const VolumeInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 5px;
`;
